import CoachAPI from '~/common/api/coachPlatformAPI';
import {
  PROFILE_GET_PROGRAMME_STATUS_BEGIN,
  PROFILE_GET_PROGRAMME_STATUS_SUCCESS,
  PROFILE_GET_PROGRAMME_STATUS_FAILURE,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getProgrammeStatus(userID) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PROFILE_GET_PROGRAMME_STATUS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = CoachAPI.get(`/tag/show/${userID}`);

      doRequest.then(
        res => {
          dispatch({
            type: PROFILE_GET_PROGRAMME_STATUS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: PROFILE_GET_PROGRAMME_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROFILE_GET_PROGRAMME_STATUS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        programme: undefined,
        getProgrammeStatusPending: true,
        getProgrammeStatusError: null,
      };

    case PROFILE_GET_PROGRAMME_STATUS_SUCCESS:
      // The request is success
      return {
        ...state,
        programme: action.data,
        getProgrammeStatusPending: false,
        getProgrammeStatusError: null,
      };

    case PROFILE_GET_PROGRAMME_STATUS_FAILURE:
      // The request is failed
      return {
        ...state,
        getProgrammeStatusPending: false,
        getProgrammeStatusError: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/profile/redux/getProgrammeStatus.js